import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
  useToast,
  Checkbox,
  Flex,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  Textarea,
} from '@chakra-ui/react'
import { api } from '../../../../../../services/api'
import { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useOrcamentoPedido } from '../../../../../../contexts/OrcamentoPedidoProvider'
import { Input } from '../../../../../../components/Form/Input'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Button } from '../../../../../../components/Button'
import { UploadArquivo } from './UploadArquivo'
// import { useMutation } from 'react-query'

const schema = z.object({
  observacao_vendedor: z.string().nonempty('Campo de observação é obrigatório!'),
  valor_chegar: z
    .number({
      required_error: 'O valor a chegar é obrigatório',
      invalid_type_error: 'O valor deve ser um número válido',
    })
    .positive('O valor deve ser maior que zero'),
})

async function updateNegociacao(data) {
  const response = await api.post('/site/v2/orcamento-crm/envia-negociacao', data)

  return response.data
}

async function onRemoveNegociacao(data) {
  const res = await api.put('/site/v2/orcamento-crm/romover-negociacao', data)
  return res.data
}

export function SolicitarNegociacao({ item, nome_vendedor, codigo_vendedor }) {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const { fnRecalculateProductPrice, infoProposta } = useOrcamentoPedido()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  })

  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  const { mutateAsync: removeNegociacao, isLoading: isLoadingRemoveNegociacao } = useMutation({
    mutationFn: onRemoveNegociacao,
    onSuccess: () => {
      toast({
        title: 'Negociação removida!',
        status: 'success',
      })

      queryClient.invalidateQueries('items')
    },
    onError: () => {
      toast({
        title: 'Erro ao remover negociação',
        status: 'error',
      })
    },
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updateNegociacao,
    onSuccess: (data) => {
      onClose()

      queryClient.invalidateQueries('negociacao-historico')

      queryClient.setQueryData(['items', item.numero_nota], (oldData) => {
        return {
          ...oldData,
          itens: oldData.itens.map((oldItem) => {
            if (oldItem.codigo_produto === item.codigo_produto && oldItem.sequencia === item.sequencia) {
              return {
                ...oldItem,
                negociacao: data.negociacao,
              }
            }
            return oldItem
          }),
        }
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao enviar negociação',
        status: 'error',
      })
    },
  })

  const [neg, setNeg] = useState(item.negociacao)

  console.log(item)

  async function handleUpdateNeg(valor_chegar, observacao_vendedor) {
    const params = {
      numero_nota: item.numero_nota,
      codigo_produto: item.codigo_produto,
      sequencia: item.sequencia,
      nome_produto: item.nome_produto,
      gravacao_produto: item.nome_personalizacao,
      cor_produto: item.descricao_cor || null,
      quantidade_batidas: item.cubagem?.dimensoes?.batidas || null,
      quantidade_produto: item.quantidade || null,
      prazo_producao: item.prazo || null,
      valor_atual: item.original_preco_base,
      valor_chegar: valor_chegar,
      vendedor: nome_vendedor,
      codigo_vendedor: codigo_vendedor,
      link_imagem_produto: item.imagens_produto?.[0]?.url || null,
      observacao_vendedor: observacao_vendedor,
      numero_pedido: infoProposta.numero_pedido,
    }

    setNeg(true)

    await mutateAsync(params)

    fnRecalculateProductPrice(true)
  }

  async function handleRemoveNegociacao() {
    await removeNegociacao({
      numero_nota: item.numero_nota,
      codigo_produto: item.codigo_produto,
      sequencia: item.sequencia,
    })
  }

  async function onSubmit(data) {
    console.log(data)

    await handleUpdateNeg(data.valor_chegar, data.observacao_vendedor)
  }

  return (
    <>
      <Flex
        pointerEvents={!infoProposta?.valida_bloqueio && 'auto'}
        alignItems={'center'}
        justifyContent={'center'}
        px={4}
        transition="filter 0.3s"
        fontWeight="semibold"
        bgColor="transparent"
        fontSize="13px"
        as="label"
        htmlFor="solicitar-negociacao"
        size="sm"
        color="#2D2D2D"
        cursor="pointer"
        isLoading={isLoading}
        _hover={{ filter: 'brightness(0.9)', bgColor: '#d3d3d3' }}
      >
        Enviar para negociação
        <Checkbox isChecked={neg} ml={2} size="md" colorScheme="blue" borderColor="#378BBF" onChange={onOpen} />
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>Solicitar Negociação</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input label="Valor a Chegar" type="number" step="0.01" {...register('valor_chegar', { valueAsNumber: true })} />
            {errors.valor_chegar && <p style={{ color: 'red' }}>{errors.valor_chegar.message}</p>}
            <Textarea
              mt={2}
              placeholder="Observação do Vendedor"
              resize="none"
              borderRadius={0}
              borderColor="#ffa200"
              _focus={{
                outline: 'none',
              }}
              {...register('observacao_vendedor')}
            />

            {errors.valor_chegar && <p style={{ color: 'red' }}>{errors.observacao_vendedor.message}</p>}

            <UploadArquivo item={item} />
          </ModalBody>

          <ModalFooter>
            <Button bgColor="yellow.500" onClick={handleRemoveNegociacao} isLoading={isLoadingRemoveNegociacao} mr="auto">
              Remover Negociação
            </Button>
            <Button bgColor="green.500" type="submit" isLoading={isLoading} mr={2}>
              Confirmar
            </Button>
            <Button bgColor="red.500" type="reset" onClick={onClose}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
